export default __webpack_public_path__ + "static/media/ic_duration_48px.f1260eb5.svg";